<template>
  <dialog
    id="mobile-navigation"
    data-testid="mobile-navigation"
    ref="dialog"
    class="editorial-mobile-menu"
    aria-label="Navigation"
    @cancel.prevent="close"
    @keydown.tab="trapFocus"
    @click="onBackdropClick"
  >
    <div class="mobile-menu-heading">
      <EditorialWordmark />
      <button class="editorial-pill" autofocus aria-label="Close navigation menu" data-testid="menu-close" @click="close">
        Close ✕
      </button>
    </div>
    <NavBarItems @click="close" />
    <NuxtLink to="/login" class="editorial-pill" data-testid="menu-account" @click="close">Your account ↗</NuxtLink>
  </dialog>
</template>
<script setup lang="ts">
const emit = defineEmits(['close:menu'])
const dialog = ref<HTMLDialogElement>()
let previousFocus: HTMLElement | null = null
let previousOverflow = ''
const close = () => emit('close:menu')
const trapFocus = (event: KeyboardEvent) => {
  const controls = dialog.value?.querySelectorAll<HTMLElement>('a[href], button:not([disabled])')
  if (!controls?.length) return
  const first = controls[0]
  const last = controls[controls.length - 1]
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault()
    last.focus()
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault()
    first.focus()
  }
}
const onBackdropClick = (event: MouseEvent) => {
  if (event.target === dialog.value) {
    const bounds = dialog.value.getBoundingClientRect()
    if (
      event.clientX < bounds.left ||
      event.clientX > bounds.right ||
      event.clientY < bounds.top ||
      event.clientY > bounds.bottom
    )
      close()
  }
}
onMounted(() => {
  previousFocus = document.activeElement as HTMLElement
  previousOverflow = document.body.style.overflow
  document.body.style.overflow = 'hidden'
  dialog.value?.showModal()
})
onBeforeUnmount(() => {
  dialog.value?.close()
  document.body.style.overflow = previousOverflow
  previousFocus?.focus()
})
</script>
